import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const client = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// اضافه کردن Token
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// مدیریت خطاها - Auto Logout
client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // اگر 401 یا 403 (Forbidden)
    if (error.response?.status === 401 || error.response?.status === 403) {
      
      // اگر Refresh داری و هنوز retry نشده
      if (!originalRequest._retry) {
        originalRequest._retry = true;

        try {
          const refreshToken = localStorage.getItem('refresh');
          if (!refreshToken) throw new Error('No refresh token');

          const response = await axios.post(`${API_BASE_URL}/users/refresh/`, {
            refresh: refreshToken,
          });

          const { access, refresh } = response.data;
          localStorage.setItem('access', access);
          localStorage.setItem('refresh', refresh);

          originalRequest.headers.Authorization = `Bearer ${access}`;
          return client(originalRequest);
        } catch (refreshError) {
          // Refresh هم کار نکرد → Logout
          console.log('Token منقضی شد - خروج خودکار');
          localStorage.clear();
          window.location.href = '/login';
          return Promise.reject(refreshError);
        }
      } else {
        // قبلاً retry شده و باز هم 401/403 → Logout
        console.log('خطای احراز هویت - خروج خودکار');
        localStorage.clear();
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default client;